import { useState } from "react";
import SectionTitle from "./common/SectionTitle";

const projects = [
	{
		id: 1,
		title: "E-commerce Platform",
		category: "web",
		image: "ecommerce.avif",
		description:
			"Custom e-commerce solution with integrated payment processing",
	},
	{
		id: 2,
		title: "Healthcare Management System",
		category: "software",
		image: "healthcare.jpg",
		description: "Comprehensive patient management system for clinics",
	},
	{
		id: 3,
		title: "Mobile Banking App",
		category: "mobile",
		image: "banking.avif",
		description: "Secure mobile banking application for financial institution",
	},
	{
		id: 4,
		title: "IoT Smart Home Solution",
		category: "iot",
		image: "iot.jpg",
		description: "Connected home automation system with AI capabilities",
	},
	{
		id: 5,
		title: "Corporate Website Redesign",
		category: "web",
		image: "corporate.jpg",
		description: "Modern responsive website for international corporation",
	},
	{
		id: 6,
		title: "Inventory Management System",
		category: "software",
		image: "inventory.jpeg",
		description: "Cloud-based inventory tracking for retail chain",
	},
];

const Portfolio = () => {
	const [activeFilter, setActiveFilter] = useState("all");

	const filteredProjects =
		activeFilter === "all"
			? projects
			: projects.filter((project) => project.category === activeFilter);

	return (
		<section className="portfolio">
			<div className="flex flex-col items-center justify-center w-full h-full py-20 bg-gray-100">
				<SectionTitle title="Our Portfolio" subtitle="See our recent work" />

				<div className="portfolio-filters">
					<button
						className={activeFilter === "all" ? "active" : ""}
						onClick={() => setActiveFilter("all")}
					>
						All
					</button>
					<button
						className={activeFilter === "web" ? "active" : ""}
						onClick={() => setActiveFilter("web")}
					>
						Web
					</button>
					<button
						className={activeFilter === "software" ? "active" : ""}
						onClick={() => setActiveFilter("software")}
					>
						Software
					</button>
					<button
						className={activeFilter === "mobile" ? "active" : ""}
						onClick={() => setActiveFilter("mobile")}
					>
						Mobile
					</button>
					<button
						className={activeFilter === "iot" ? "active" : ""}
						onClick={() => setActiveFilter("iot")}
					>
						IoT
					</button>
				</div>

				<div className="portfolio-grid w-full px-5 ">
					{filteredProjects.map((project) => (
						<div key={project.id} className="portfolio-item">
							<div className="portfolio-image">
								<img
									src={`/assets/images/portfolio/${project.image}`}
									alt={project.title}
								/>
								<div className="portfolio-overlay">
									<h3>{project.title}</h3>
									<p>{project.description}</p>
									<button className="view-button">View Details</button>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Portfolio;
